// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* AspectRatioSlider.css */
.aspect-ratio-slider-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 15px 0;
  width: 100%;
}

.aspect-ratio-preview {
  margin-bottom: 8px;
  color: var(--tg-theme-text-color); 
  opacity: 0.7;
}

/* --- НОВЫЙ КОД: Стили для боковых превью-хоткеев --- */
.aspect-ratio-hotkey {
  cursor: pointer;
  opacity: 0.5;
  transition: opacity 0.2s ease-in-out;
}

.aspect-ratio-hotkey:hover {
  opacity: 1;
}
/* --- НОВЫЙ КОД: Конец --- */

.aspect-ratio-slider {
  appearance: none;
  width: 90%;
  height: 8px;
  border-radius: 5px;
  background-color: rgba(154, 154, 154, 0.2); 
  outline: none;
  cursor: pointer;
}

.aspect-ratio-slider::-webkit-slider-thumb {
  appearance: none;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: var(--tg-theme-button-color);
  cursor: pointer;
}

.aspect-ratio-slider::-moz-range-thumb {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: var(--tg-theme-button-color);
  cursor: pointer;
  border: none;
}`, "",{"version":3,"sources":["webpack://./src/components/menus/settings/AspectRatioSlider.css"],"names":[],"mappings":"AAAA,0BAA0B;AAC1B;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;EACjC,YAAY;AACd;;AAEA,wDAAwD;AACxD;EACE,eAAe;EACf,YAAY;EACZ,oCAAoC;AACtC;;AAEA;EACE,UAAU;AACZ;AACA,6BAA6B;;AAE7B;EAEE,gBAAgB;EAChB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,0CAA0C;EAC1C,aAAa;EACb,eAAe;AACjB;;AAEA;EAEE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,wCAAwC;EACxC,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,wCAAwC;EACxC,eAAe;EACf,YAAY;AACd","sourcesContent":["/* AspectRatioSlider.css */\r\n.aspect-ratio-slider-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  margin: 15px 0;\r\n  width: 100%;\r\n}\r\n\r\n.aspect-ratio-preview {\r\n  margin-bottom: 8px;\r\n  color: var(--tg-theme-text-color); \r\n  opacity: 0.7;\r\n}\r\n\r\n/* --- НОВЫЙ КОД: Стили для боковых превью-хоткеев --- */\r\n.aspect-ratio-hotkey {\r\n  cursor: pointer;\r\n  opacity: 0.5;\r\n  transition: opacity 0.2s ease-in-out;\r\n}\r\n\r\n.aspect-ratio-hotkey:hover {\r\n  opacity: 1;\r\n}\r\n/* --- НОВЫЙ КОД: Конец --- */\r\n\r\n.aspect-ratio-slider {\r\n  -webkit-appearance: none;\r\n  appearance: none;\r\n  width: 90%;\r\n  height: 8px;\r\n  border-radius: 5px;\r\n  background-color: rgba(154, 154, 154, 0.2); \r\n  outline: none;\r\n  cursor: pointer;\r\n}\r\n\r\n.aspect-ratio-slider::-webkit-slider-thumb {\r\n  -webkit-appearance: none;\r\n  appearance: none;\r\n  width: 22px;\r\n  height: 22px;\r\n  border-radius: 50%;\r\n  background: var(--tg-theme-button-color);\r\n  cursor: pointer;\r\n}\r\n\r\n.aspect-ratio-slider::-moz-range-thumb {\r\n  width: 22px;\r\n  height: 22px;\r\n  border-radius: 50%;\r\n  background: var(--tg-theme-button-color);\r\n  cursor: pointer;\r\n  border: none;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
